// App configuration.
//
// URLs are environment-driven via CRA REACT_APP_* vars (baked at build time). The defaults
// below target PRODUCTION, so a plain `npm run build` is correct with no extra setup. Local
// dev and other environments override through .env.development / .env.production / .env*.local
// — see the committed .env.development, which points auth at the local .NET API.
//
// Reader content no longer calls WordPress directly: `baseURL` points at the .NET content
// gateway (api/v1/Content), which injects the WordPress spKey server-side and authenticates
// with the user's JWT. The old direct wp-json browser calls and the setupProxy.js CORS shim
// are gone.
const authBaseURL =
  process.env.REACT_APP_AUTH_BASE_URL || 'https://webapi.regulationcity.com/api';

const config = {
  authBaseURL,
  // .NET content gateway base (reader content). Derived from authBaseURL unless overridden.
  baseURL: process.env.REACT_APP_CONTENT_BASE_URL || `${authBaseURL}/v1/Content`,
  HomeURL: '/app',
  AppURL: process.env.REACT_APP_APP_URL || 'https://regulationcity.com/app',
  // WordPress origin is still used to resolve public media (image) URLs in content HTML.
  WordPressURL: process.env.REACT_APP_WORDPRESS_URL || 'https://regulationcity.com/',
  ImagesFolder:
    'https://adminwordflow.sharepoint.com/sites/RegulationCity/PublishingImages/',
};

export default config;
